<template>
  <br />
  <h2 class="text-center my-2">ALL CLIENT TRADES</h2>
  <br />
  <div>
    <Button icon="pi pi-info" class="p-button-rounded p-button-lg mx-4 shadow-5" @click="toggle" />
    <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 20rem" :breakpoints="{'960px': '75vw'}">
      <p>Use the <i class="pi pi-sort-alt"></i> to filter results.</p>
      <p>Use <i class="pi pi-sort-amount-up-alt"></i> or <i class="pi pi-sort-amount-down-alt"></i> to change the sort order.</p>
      <p>To filter by multiple columns use Ctrl + Click on the second filter column.</p>
      <p>Use the <i class="pi pi-filter"></i> to search for a specific client. You can search on multiple columns.</p>
      </OverlayPanel>
  </div>
  <br />
    <div class="fluid mx-3 shadow-2">
        <DataTable :value="trades"
                    dataKey="id" :rowHover="true"
                    stripedRows responsiveLayout="stack"
                    sortMode="multiple"
                    showGridlines
                    breakpoint="1024px"
                    :paginator="true"
                    :rows="8"
                    v-model:filters="filters1"
                    filterDisplay="menu"
                    class="datatable-retailClient">
            <Column field="partnerName" header="Partner" :sortable="true" headerStyle="width: 3vw">
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Partner"/>
              </template>
            </Column>
            <Column field="firstLastName" header="Client" :sortable="true" headerStyle="width: 5vw">
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Name"/>
              </template>
            </Column>
            <Column field="valueDate" header="Value Date" :sortable="true" headerStyle="width: 3vw">
              <template #filter="{filterModel}">
                <InputText type="date" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Date"/>
              </template>
            </Column>
            <Column field="dealNumber" header="Deal No" headerStyle="width: 3vw">
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Deal Number"/>
              </template>
            </Column>
            <Column field="buySell" header="Buy/Sell" :sortable="true" headerStyle="width: 3vw"></Column>
            <Column field="dealRate" header="Rate" headerStyle="width: 3vw">
                <template #body="{data}">
                    {{formatRate(data.dealRate)}}
                </template>
            </Column>
            <Column field="currency1" header="Currency 1" headerStyle="width: 3vw"></Column>
            <Column field="currency1Amount" header="Amount" dataType="numeric" headerStyle="width: 3vw">
                <template #body="{data}">
                    {{formatCurrency(data.currency1Amount)}}
                </template>
            </Column>
            <Column field="currency2" header="Currency 2" headerStyle="width: 3vw"></Column>
            <Column field="currency2Amount" header="Amount" dataType="numeric" headerStyle="width: 3vw">
                <template #body="{data}">
                    {{formatCurrency(data.currency2Amount)}}
                </template>
            </Column>
        </DataTable>
     </div>
   <br />
  <div class="flex justify-content-between ">
        <div>
          <Button class="l-2 m-3 mx-4 shadow-3 p-button-lg"
          icon="pi pi-step-backward"
          label="BACK&nbsp;"
          id="submitButton"
          @click.prevent="$router.back()" />
      </div>
      <div>
          <Button class="l-2 m-3 mx-4 shadow-3 p-button-lg "
          icon="pi pi-file-excel"
          label="DOWNLOAD&nbsp;"
          id="excelButton"
          @click.prevent="$router.push( {name: 'AllTradesFileDownload' })" />
      </div>
  </div>
</template>

<script>
import { getAllTrades } from '@/gateway'
import { FilterMatchMode, FilterOperator } from 'primevue/api'

export default {
  name: 'AllTradesView',
  inheritAttrs: false,
  data () {
    return {
      trades: [],
      filters1: null
    }
  },
  methods: {
    async init () {
      const response = await getAllTrades()
      if (response) {
        this.trades = response.result
      }
    },
    formatCurrency (value) {
      return value.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 })
    },
    formatRate (value) {
      return value.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 4, minimumFractionDigits: 4 })
    },
    initFilters1 () {
      this.filters1 = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        partnerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        firstLastName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        valueDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        dealNumber: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
      }
    },
    toggle (event) {
      this.$refs.op.toggle(event)
    }
  },
  created () {
    this.initFilters1()
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-button-label {
    flex: none;
  }
  .p-datatable .p-datatable-thead > tr > th {
    background-color: $middleBlue!important;
    color: $textColor;
    border: 1px solid $borderColour!important;
    font-size: 18px;
    font-weight: 600;
  }
  .p-datatable .p-datatable-tbody > tr > td {
    padding: .4rem .4rem;
    color: $darkTextColour;
    font-family:'Poppins', sans-serif;
    font-weight: 400;
  }
  .p-paginator-current {
        margin-right: auto;
    }
  .retailClient-badge {
      @include statusBadge
  };
  #disabled {
    background: $textColor!important;
    color: $middleBlue!important;
  };
  #searchtext {
    min-width: 40vw;
  };
};
</style>
